import React, { useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { formatearFecha } from '../../../../_mexablock/helpers';
import { formatDateMonth } from '../../../../_mexablock/helpers';
import { CollapseGraphic } from './CollapseGraphic';

type Props = {
  showGraphic?: boolean;
  dataOffer?: any;
  dataByDate?: any;
  dataByAPP?: any;
  onClearFiltros?: () => void;
  onChangeOferta?: (oferta: {
    offer_id: number;
    created_at: string;
    due_date: string;
  }) => void;
};

const FiltrosConsumosDatos: React.FC<Props> = ({
  showGraphic,
  dataOffer,
  dataByDate,
  dataByAPP,
  onChangeOferta,
  onClearFiltros,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [vigenciaTexto, setVigenciaTexto] = useState('');
  const [offerName, setOfferName] = useState('');
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const [mesSeleccionado, setMesSeleccionado] = useState<number | ''>('');
  const [ofertaSeleccionada, setOfertaSeleccionada] = useState<{
    offer_id: number;
    created_at: string;
    due_date: string;
  } | null>(null);

  const meses = [
    { label: 'Enero', value: 1 },
    { label: 'Febrero', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Mayo', value: 5 },
    { label: 'Junio', value: 6 },
    { label: 'Julio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Septiembre', value: 9 },
    { label: 'Octubre', value: 10 },
    { label: 'Noviembre', value: 11 },
    { label: 'Diciembre', value: 12 },
  ];

  const ConsumoSchema = Yup.object().shape({
    msisdn: Yup.string().when('selection', {
      is: 'msisdn',
      then: Yup.string()
        .matches(/^\d{10}$/, 'MSISDN debe tener 10 dígitos')
        .required('MSISDN es requerido'),
    }),
    iccid: Yup.string().when('selection', {
      is: 'iccid',
      then: Yup.string()
        .matches(/^\d{19}$/, 'ICCID debe tener 19 dígitos')
        .required('ICCID es requerido'),
    }),
  });
  const formik = useFormik({
    validationSchema: ConsumoSchema,
    initialValues: {
      offer_id: 0,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      setIsSubmitting(true);

      formik.resetForm();
      setOfertaSeleccionada(null);
      setMesSeleccionado('');
      setOfferName('');
      setVigenciaTexto('');
      onClearFiltros?.();

      setTimeout(() => {
        setIsSubmitting(false);
      }, 1000);
    },
  });

  const handleChangeMes = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = parseInt(e.target.value);
    setMesSeleccionado(isNaN(value) ? '' : value);
  };

  const ofertasFiltradas = mesSeleccionado
    ? dataOffer.filter((item: any) => {
        const mes = new Date(item.created_at).getUTCMonth() + 1;
        return mes === mesSeleccionado;
      })
    : dataOffer;

  const handleChangeOferta = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = parseInt(e.target.value);
    const seleccion = ofertasFiltradas.find(
      (item: any) => item.id === selectedId
    );

    if (seleccion) {
      const oferta = {
        offer_id: seleccion.offer.id,
        created_at: seleccion.created_at,
        due_date: seleccion.due_date,
      };

      setOfertaSeleccionada(oferta);
      onChangeOferta?.(oferta);

      formik.setFieldValue('offer_id', selectedId);

      const inicio = formatDateMonth(seleccion.created_at);
      const fin = formatDateMonth(seleccion.due_date);
      setVigenciaTexto(`Del ${inicio} al ${fin}`);
      setOfferName(seleccion.offer.mexablock_name);
    }
  };

  return (
    <>
      <div className="card card-custom mb-10">
        <form
          id="kt_search_sales_form"
          className="form"
          action="#"
          onSubmit={formik.handleSubmit}
        >
          <div className="card-header">
            <div className="container">
              <div className="row p-3 mb-3">
                <div className="col-md-6 text-left">
                  <div className="row">
                    <div className="col-md-6 justify-content-start align-items-center mt-3">
                      <label className="fw-bold fs-7 mb-2 ms-2 w-auto">
                        Filtrar por mes
                      </label>
                      <select
                        className="form-select"
                        value={mesSeleccionado}
                        onChange={handleChangeMes}
                      >
                        <option value="">Seleccione</option>
                        {meses.map((mes) => (
                          <option key={mes.value} value={mes.value}>
                            {mes.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 justify-content-start align-items-center mt-3">
                      <label className="fw-bold fs-7 mb-2 ms-2 w-auto">
                        Filtrar por paquete
                      </label>
                      <select
                        className="form-select"
                        value={formik.values.offer_id}
                        onChange={handleChangeOferta}
                      >
                        <option value={0}>Seleccione</option>
                        {ofertasFiltradas.map((item: any) => (
                          <option key={item.id} value={item.id}>
                            {`${item.offer.mexablock_name} ${formatearFecha(
                              item.created_at
                            )} - ${formatearFecha(item.due_date)}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 text-end">
                  <div className="row d-flex justify-content-end">
                    <div className="col-md-6 d-flex justify-content-center align-items-center mt-7">
                      <button
                        ref={btnRef}
                        type="submit"
                        style={{ backgroundColor: 'orange', color: 'white' }}
                        className={`btn ${
                          isSubmitting
                            ? 'kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light'
                            : ''
                        }`}
                        id="kt_button_1"
                        disabled={isSubmitting}
                      >
                        <i className="bi bi-eraser fs-5 text-white" />
                        <span className="indicator-label fs-7">
                          {isSubmitting ? 'Espere...' : 'Limpiar'}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      {showGraphic && dataByDate && (
        <CollapseGraphic
          dataView={dataByDate}
          dataAPP={dataByAPP}
          collapse={true}
          vigencia={vigenciaTexto}
          name={offerName}
        />
      )}
    </>
  );
};
export { FiltrosConsumosDatos };
